import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLog } from '../../context/LogContext';
import { API_BASE_URL } from '../../utils/config';
import NewTopNavBar from '../NewTopNavBar';

const LoggerFile = () => {
    const [data, setData] = useState(null);
    const { logApiRequest, downloadLog } = useLog();

    const fetchData = async () => {
        const request = {
            method: 'GET',
            url: `${API_BASE_URL}/wp-json/wp/v2/posts`
        };

        try {
            const response = await axios(request);
            setData(response.data);

            // Log the successful request and response
            // logApiRequest(request, response);
        } catch (error) {
            // Log the failed request and response
            // logApiRequest(request, error.response || { status: error.message });

            console.error('API request failed', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <div>
                <NewTopNavBar />
            </div>
            {/* {data ? (
                data.map(post => (
                    <div key={post.id}>
                        <h2>{post.title.rendered}</h2>
                        <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
                    </div>
                ))
            ) : (
                <p>Loading...</p>
            )} */}
            <button onClick={downloadLog}>Download Log</button>
        </div>
    );
};

export default LoggerFile;
